/**
 * Shared types for Client Profile contacts (Contacts tab + Medical Record contact modal).
 */

export const CONTACT_RELATIONSHIP_TYPES = [
  'Child',
  'Dependent',
  'Family Member',
  'Legal Guardian',
  'Physician',
  'Parent',
  'Partner',
  'Spouse',
  'Patient',
  'Other',
] as const;

export type ContactRelationshipType = (typeof CONTACT_RELATIONSHIP_TYPES)[number];

/** Storage/taxonomy used by Caseload Contacts and the profile contact modal. */
export const CONTACT_KINDS = ['emergency-contact', 'related-person', 'guarantor'] as const;
export type ContactKind = (typeof CONTACT_KINDS)[number];
export const CONTACT_KIND_LABELS: Record<ContactKind, string> = {
  'emergency-contact': 'Emergency contact',
  'related-person': 'Related Person',
  'guarantor': 'Guarantor',
};

export interface ContactPhone {
  value: string;
  type?: string;
}

/** Where this contact record is stored in FHIR. */
export type ContactSource = 'patient-contact' | 'related-person';

export interface Contact {
  id: string;
  /** FHIR storage origin — determines which resource to update on save. */
  source: ContactSource;
  /** For RelatedPerson contacts: the RelatedPerson.id (without prefix). */
  relatedPersonId?: string;
  /** Whether the underlying resource is active (RelatedPerson.active). */
  active?: boolean;
  legalFirstName: string;
  middleName?: string;
  legalLastName: string;
  suffix?: string;
  preferredName?: string;
  relationshipType: ContactRelationshipType;
  /** Emergency / Related Person / Guarantor — independent of family relationship. */
  contactKind?: ContactKind;
  isEmergencyContact: boolean;
  emails?: string[];
  phones?: ContactPhone[];
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
  notes?: string;
  role?: string;
  organization?: string;
}
